import request from '../utils/request'

export function getHttp(url,data) {
  return request({
    url: url,
    method: 'get',
    data
  })
}

export function postHttp(url,data) {
  return request({
    url: url,
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/http.js